module.exports = __webpack_public_path__ + "static/media/DEP-BNB.fd62646a.png";